import React from "react";
import "./PageHeader.scss";
import Box from "@mui/material/Box";

const PageHeader = ({ children }: any) => {
  return (
    <Box
      className="pageHeader"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      {children}
    </Box>
  );
};

export default PageHeader;
